import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import acLogo from "../../assets/images/ac-logo-white.svg";
import {
  FooterContainer,
  FooterContent,
  FooterFirstDiv,
  FooterSecondDiv
} from "./Footer.style";

function Footer() {
  const { t } = useTranslation();
  return (
    <FooterContainer>
      <FooterContent>
        <FooterFirstDiv>
          <img src={acLogo} alt="Air Canada Logo" />
        </FooterFirstDiv>
        <FooterSecondDiv>
          <Typography component="p">
            {t("all.footer.label.sub-link-copyright")}
          </Typography>
        </FooterSecondDiv>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer;
